import { useQuery } from 'react-query';

import {
  savedMessagesKey,
  SavedMessage,
} from '@features/savedMessages';
import axiosInstance from '@server/axiosInstance';
import { Dispatch, SetStateAction } from 'react';
import { tampleteSavedMessagesRoute } from '../api/constants';
import { errorMessage } from '@features/applicationQuestions';

type useGetTemplateSavedMessagessProps = {
  templateId?: string | number;
  setErrorText?: Dispatch<SetStateAction<string>>;
};

export const useGetTemplateSavedMessages = ({
  templateId,
  setErrorText = () => { },
}: useGetTemplateSavedMessagessProps) => {

  const { data: savedMessages, isFetching: isLoadingSavedMessages } = useQuery<{ object?: SavedMessage[] }>(
    [savedMessagesKey],
    {
      queryFn: () =>
        axiosInstance.get(`${tampleteSavedMessagesRoute}?etemplate_id=${templateId}`).then((res) => res.data),
      onSuccess: (data) => {
        setErrorText('');
      },
      onError: () => {
        setErrorText(errorMessage);
      },
    },
  );

  return {
    savedMessages,
    isLoadingSavedMessages
  };
};
